<template>
  <div class="page">
    <wk-search
      class="wrapBox"
      :search-control-data="searchControlData"
      @search="search($event)"
    ></wk-search>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div style="line-height: 40px">共{{total}}条数据</div>
        <el-button class="common-button" v-auth="permission.ALLIANCE_ACTIVITY_ADD"   type="primary" @click="add()">
          添加联盟活动
        </el-button>
      </div>
      <el-table
        v-auth="permission.ALLIANCE_ACTIVITY_LIST"
        class="tableBox"
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="年份">
        </el-table-column>
        <el-table-column
          align="center"
          prop="desc"
          label="描述"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifyTime"
          label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.modifyTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
                align="center"
                prop="state"
                width="80"
                label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == '1'">启用</span>
            <span v-if="scope.row.state == '2'">关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button  v-auth="permission.ALLIANCE_ACTIVITY_EDIT"  class="color-blue link-button" type="text"
                       @click="edit(scope.row.id)">编辑
            </el-button>
            <el-button v-auth="permission.ALLIANCE_ACTIVITY_CONTROL"  class="color-blue link-button" type="text"
                       @click="changeStatus(scope.row)">{{scope.row.state == '1'?'关闭':'开启'}}
            </el-button>
            <el-button v-auth="permission.ALLIANCE_ACTIVITY_DELETE"  class="color-blue link-button" type="text"
                       @click="deleteClick(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50]"
          :page-size="searchFormData.perPage"
          :current-page="searchFormData.page"
          layout="total, prev, pager, next, sizes"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
  import store from '@/store/index.js';
  export default {
    beforeRouteEnter: (to,from,next) => {
      store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name: "资讯管理", path: to.fullPath} );
      next()
    },
    data() {
      return {
        total: 0,
        dialogVisible: false,
        loading: false,
        searchFormData: {
          page: 1,
          perPage: 10,
        },
        searchControlData: [
          {
            type: 'year',
            label: '年份',
            key: 'title'
          },
          {
            type: 'select',
            label: '状态',
            placeholder: '请选择状态',
            key: 'state',
            option: [
              {
                label: '全部',
                value: ''
              },
              {
                label: '开启',
                value: '1'
              },
              {
                label: '关闭',
                value: '2'
              }, 
            ]
          }
        ],
        tableData: []
      }
    },
    watch: {
      '$route.query.date' () {
        window.location.reload();
      },
    },
    created() {
      this.search()
    },
    methods: {
      search(data) {
        this.loading = true
        if (data) {
          Object.assign(this.searchFormData, data)
          if(data.title){
            this.searchFormData.title = data.title.getFullYear()
          }
          this.searchFormData.page = 1
        }
        this.$apis.activityServer.queryList(this.searchFormData).then(res => {
          if (res['code'] == 0 && res.data.data) {
            this.total = res.data.total
            this.tableData = res.data.data
          } else {
            this.total = 0
            this.tableData = []
          }
          this.loading = false
        })
      },
      add(){
        this.$router.push({
          path:'/activity/info',
          query:{
            type: 'add'
          }
        })
      },
      edit(id) {
       this.$router.push({
         path:'/activity/info',
         query:{
          type: 'edit',
          id: id
         }
       })
      },
      changeStatus(data) {
        // state: banner的当前状态： 1：开启；2：关闭
        if (data.state == 1) {
          this.$confirm('确定关闭该活动？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'cancelButton',
            confirmButtonClass: 'confirmButton',
            center: true
          }).then(() => {
            this.$apis.activityServer.close({
              id: data.id
            }).then(res => {
              if (res['code'] == 0) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '关闭成功!'
                });
              }
            })
          })
        } else {
          this.$confirm('确定开启该活动？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'cancelButton',
            confirmButtonClass: 'confirmButton',
            center: true
          }).then(() => {
            this.$apis.activityServer.open({
              id: data.id
            }).then(res => {
              if (res['code'] == 0) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '启用成功!'
                });
              }
            })
          })
        }
      },
      deleteClick(id) {
        this.$confirm('确定删除该活动吗', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancelButton',
          confirmButtonClass: 'confirmButton',
          type: 'info ',
          center: true
        }).then(() => {
          this.$apis.activityServer.delete({
            id: id
          }).then(res => {
            if (res['code'] == 0) {
              this.search()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        })
      },
      handleSizeChange(val) {
        this.searchFormData.perPage = val
        this.search()
      },
      handleCurrentChange(val) {
        this.searchFormData.page = val
        this.search()
      }
    }
  }
</script>

<style scoped lang="scss">
</style>